<template>
    <div class="ajax-loader-bg" >
        <div class="ajax-loader-container animate__animated animate__bounceIn animate__delay-1s">
            <img src="../assets/bg/intentar-denuevo.png" />
        </div>
        <div class="contbut animate__animated animate__bounceIn animate__delay-1s">
            <a class="buprin buintentar"  @click="ctrlCerrar" role="button"><i class="fas fa-angle-left"></i> VOLVER</a>
        </div>
    </div>
    
</template>

<script>
export default {
    methods:{
        ctrlCerrar(){
            this.$emit('accionCerrar')
        }
    }
}
</script>

<style>

.ajax-loader-bg {
    left: 0px;
    top: 0px;
    position: fixed;
    width: 100%;
    height: 1000px;
    z-index: 9998;
    background: rgba(255, 255, 255,0.8);
}

.ajax-loader-container {
    width: 800px;
    z-index: 9999;
    margin: auto;
    margin-top: 200px;
}

.ajax-loader-container img {
    width: 100%;
}

</style>